angular
  .module('affiliateCompany')
  .component('affiliateCompany', {
    template: require('./affiliate-company.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function AffiliateCompanyViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'affiliate';
        $rootScope.menu = 'affiliateCompany';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.total_count = 0;
        this.query = '';
        $resource(`${APIURL}/admin/affiliate`).get({ q: this.query }).$promise
          .then((data) => {
            console.log(data);
            this.affiliates = data.affiliates;
            this.total_count = data.count;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.paging = (page) => {
          $resource(`${APIURL}/admin/affiliate`).get({ page: page - 1, q: this.query },
            (data) => {
              this.affiliates = data.affiliates;
              this.total_count = data.count;
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.view = (affiliate) => {
          this.affiliate = affiliate;
          jQuery('#modal-view').modal('show');
        };
        this.useN = (affiliate) => {
          if (!confirm($translate.instant('비활성화 하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/affiliate/:id`, { id: affiliate.ID }).delete().$promise
            .then(() => {
              this.affiliates = this.affiliates.map((group) => {
                if (group.ID === this.affiliate.ID) {
                  this.affiliate.USEYN = 'N';
                  return this.affiliate;
                }
                return group;
              });
              jQuery('#modal-view').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.useY = (affiliate) => {
          if (!confirm($translate.instant('활성화 하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/affiliate/:id/use`, { id: affiliate.ID }).save().$promise
            .then(() => {
              this.affiliates = this.affiliates.map((group) => {
                if (group.ID === this.affiliate.ID) {
                  this.affiliate.USEYN = 'Y';
                  return this.affiliate;
                }
                return group;
              });
              jQuery('#modal-view').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.openModify = (affiliate) => {
          if (affiliate.USE_PRICE_TABLE === 'Y') {
            alert($translate.instant('고정가격 제휴사는 수정 할수 없습니다. 개발팀에게 문의 바랍니다.'));
            return;
          }
          this.modifyAffiliate = affiliate;
          jQuery('#modal-view').removeClass('fade');
          jQuery('#modal-view').modal('hide');
          jQuery('#modal-modify').modal('show');
        };
        this.modifySubmit = () => {
          $resource(`${APIURL}/admin/affiliate/:id`, { id: this.modifyAffiliate.ID }).save(this.modifyAffiliate).$promise
            .then(() => {
              this.affiliates = this.affiliates.map((group) => {
                if (group.ID === this.modifyAffiliate.ID) {
                  return this.modifyAffiliate;
                }
                return group;
              });
              jQuery('#modal-modify').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/affiliate-company/affiliate-company.component.js